import React from "react";
import ReactDOM from "react-dom";
import { Catalog, pageLoader } from "catalog";
import './styles.css';

const lungoTheme = {
  fontFamily: '"DM Sans", sans-serif',
  fontHeading: '"Stack Sans Headline", sans-serif',
  fontMono: '"DM Sans Mono", monospace',

  background: '#FAFAFA',
  textColor: '#141414',
  brandColor: '#141414',
  pageHeadingBackground: '#141414',
  pageHeadingTextColor: '#EBEBEB',
  pageHeadingHeight: '300',
  navBarBackground: '#EBEBEB',
  navBarTextColor: '#141414',
  sidebarColorText: '#4883B6',
  sidebarColorTextActive: '#92178A',
  linkColor: '#4883B6'
};

const pages = [
  {
    path: "/",
    title: "Úvod",
    content: pageLoader(() => import("./home.md"))
  },
  {
    title: 'Základní informace',
    pages: [
      {
        path: '/brand/basics',
        title: 'Základ značky',
        content: pageLoader(() => import('./content/base/system.md'))
      },
      {
        path: '/brand/hierarchy',
        title: 'Firemní hierarchie',
        content: pageLoader(() => import('./content/base/hierarchy.md'))
      }
    ]
  },
  {
    title: 'Typografie',
    pages: [
      {
        path: '/typography/headings',
        title: 'Nadpisy a podnadpisy',
        content: pageLoader(() => import('./content/type/headings.md'))
      },
      {
        path: '/typography/paragaphs',
        title: 'Odstavce a souvislý text',
        content: pageLoader(() => import('./content/type/paragraphs.md'))
      }
    ]
  },
  {
    title: 'Značky',
    pages: [
      {
        path: '/brands/lungo',
        title: 'LUNGO',
        content: pageLoader(() => import('./content/brands/brand_lungo.md'))
      },
      {
        path: '/brands/medical',
        styles: '/medical.css',
        title: 'LUNGO Medical',
        content: pageLoader(() => import('./content/brands/brand_medical.md'))
      },
      {
        path: '/brands/stspo',
        styles: '/stspo.css',
        title: 'LUNGO Stavební společnost',
        content: pageLoader(() => import('./content/brands/brand_stspo.md'))
      },
      {
        path: '/brands/estate',
        styles: '/estate.css',
        title: 'LUNGO Estate',
        content: pageLoader(() => import('./content/brands/brand_estate.md'))
      },
      {
        path: '/brands/invest',
        styles: '/invest.css',
        title: 'LUNGO Invest',
        content: pageLoader(() => import('./content/brands/brand_invest.md'))
      },
      {
        path: '/brands/architecture',
        styles: '/architecture.css',
        title: 'LUNGO Architecture',
        content: pageLoader(() => import('./content/brands/brand_architecture.md'))
      },
      {
        path: '/brands/education',
        styles: '/education.css',
        title: 'LUNGO Education',
        content: pageLoader(() => import('./content/brands/brand_education.md'))
      }
    ]
  },
  {
    title: 'Brand systém',
    pages: [
      {
        path: '/system/element',
        title: 'Základní stavební element',
        content: pageLoader(() => import('./content/system/element.md'))
      },
      {
        path: '/system/grid',
        title: 'Mřížka a práce s elementem',
        content: pageLoader(() => import('./content/system/grid.md'))
      },
      {
        path: '/system/alphabet',
        title: '"Lungovice"',
        content: pageLoader(() => import('./content/system/alphabet.md'))
      },
      {
        path: '/system/pattern',
        title: 'Brandový vzor',
        content: pageLoader(() => import('./content/system/pattern.md'))
      }
    ]
  }
];

ReactDOM.render(
  <Catalog title="Digitální manuál LUNGO" logoSrc="/logo.svg" pages={pages} theme={lungoTheme} />,
  document.getElementById("catalog")
);



// WEBPACK FOOTER //
// ./catalog/index.js